
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_1kxbv_97",
  "arrow": "awsui_arrow_18eso_1kxbv_97",
  "has-caret": "awsui_has-caret_18eso_1kxbv_164",
  "placeholder": "awsui_placeholder_18eso_1kxbv_167",
  "pressed": "awsui_pressed_18eso_1kxbv_180",
  "disabled": "awsui_disabled_18eso_1kxbv_183",
  "in-filtering-token": "awsui_in-filtering-token_18eso_1kxbv_193",
  "read-only": "awsui_read-only_18eso_1kxbv_199",
  "invalid": "awsui_invalid_18eso_1kxbv_221",
  "inline-tokens": "awsui_inline-tokens_18eso_1kxbv_259"
};
  